import { Box, Button, Typography } from "@mui/material";

function formatShipmentStatus(status) {
  if (!status) {
    return "";
  }

  return String(status)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function PackageSection({
  group,
  showHeader,
  t,
  showSelectAll,
  selectAllActive,
  onToggleSelectAll,
  selectAllDisabled,
  children,
}) {
  if (!showHeader) {
    return children;
  }

  const isUnshipped = group.kind === "unshipped";
  const title = isUnshipped
    ? t("resolve.package.unshipped")
    : group.trackingNumber
      ? t("resolve.package.tracking", { trackingNumber: group.trackingNumber })
      : t("resolve.package.untitled");
  const subtitle = isUnshipped
    ? t("resolve.package.processing")
    : group.status
      ? t("resolve.package.status", {
          status: formatShipmentStatus(group.status),
        })
      : null;

  return (
    <Box mb="28px">
      <Box
        mb="12px"
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "flex-start" }}
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
      >
        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {showSelectAll && (
          <Button
            size="small"
            variant={selectAllActive ? "contained" : "outlined"}
            onClick={onToggleSelectAll}
            disabled={selectAllDisabled}
            sx={{ flexShrink: 0 }}
          >
            {selectAllActive
              ? t("resolve.package.clearSelectAll")
              : t("resolve.package.selectAll")}
          </Button>
        )}
      </Box>
      {children}
    </Box>
  );
}
